import Icon from "~/components/shared/Icon";
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
  HoverCardPortal,
} from "~/components/shared/HoverCard";

export default function ClusterQueue({
  queueName,
  agentsPath,
  onNestedLinkTrigger,
}: {
  queueName?: string;
  agentsPath: string;
  onNestedLinkTrigger: (e: React.MouseEvent | React.KeyboardEvent) => void;
}) {
  return (
    <HoverCard>
      <HoverCardTrigger asChild={true}>
        <a
          href={agentsPath}
          className="badge badge--outline gapx0.5 job-stats flex min-w-[70px] max-w-[240px] items-center justify-center gap-x-1"
          onClick={onNestedLinkTrigger}
          onKeyDown={onNestedLinkTrigger}
        >
          <Icon icon="custom/outline/14x/queue" className="h-3.5 w-3.5 shrink-0" />

          {queueName ? "Queue" : "Unclustered"}
        </a>
      </HoverCardTrigger>

      {queueName && (
        <HoverCardPortal>
          <HoverCardContent
            className="z-50"
            size="max-lg"
            onClick={onNestedLinkTrigger}
            onKeyDown={onNestedLinkTrigger}
          >
            <div className="flex">
              <a href={agentsPath} className="max-w-full truncate text-inherit hover:text-inherit">
                {queueName}
              </a>
            </div>
          </HoverCardContent>
        </HoverCardPortal>
      )}
    </HoverCard>
  );
}
